import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import API_URL from './api/config';
import { useQuery } from '@tanstack/react-query';


function Welcome() {

    const verifyCode = localStorage.getItem('verify_code');

    const [values, setValues] = useState({ password: '', confirm_password: '' });
    const navigate = useNavigate();
    axios.defaults.withCredentials = true;
    //get packages
    const { data, isLoading, isError } = useQuery({
        queryKey: ['packageDetails'],
        queryFn: async () => {
          const res = await axios.get(`${API_URL}/register-package-api`, { withCredentials: true });
          return res.data;
        },
        staleTime: 0,
        cacheTime: Infinity
      });
      //get family details

      const {
        data: detailedFamily,
        isLoading: isDetailedLoading,
        isError: isDetailedError,
      } = useQuery({
        queryKey: ['familyDetails', verifyCode],
        queryFn: () =>
          axios
            .get(`${API_URL}/register-family-details-api`, {
              params: { verify_code: verifyCode },
              withCredentials: true
            })
            .then(res => res.data),
        enabled: !!verifyCode, // don't run until verifyCode exists
      });


      //get user details

      const [message, setMessage] = useState('');
    
      const [profile, setProfile] = useState({
          name: '',
          last_name: '',
          phone_number: '',
          email: '',
          profile_image: ''
          });
  
          
          const {
            data: dataProfile,
            isLoading: isLoadingProfile,
            isError: isErrorProfile,
          } = useQuery({
            queryKey: ['userProfileDetails', verifyCode],
            queryFn: async () => {
              if (!verifyCode) throw new Error("No verifyCode provided");
          
              const res = await axios.get(`${API_URL}/register-user-details-api?verifyCode=${verifyCode}`, {
                withCredentials: true,
              });
          
              return res.data;
            },
            enabled: !!verifyCode,
            staleTime: 0,
            cacheTime: Infinity,
          });
        
        
  
        useEffect(() => {
            if (dataProfile) {
              if (dataProfile.Status === "Success") {
                const user = dataProfile.user;
          
                setProfile({
                  name: user.name || '',
                  last_name: user.last_name || '',
                  phone_number: user.phone_number || '',
                  email: user.email || '',
                  profile_image: user.profile_image || '',
                });
              } else {
                setMessage("Failed to load user data");
              }
            }
          }, [dataProfile]);
  
  
      // Handle input changes
      /*const handleChange = (e) => {
          const { name, value } = e.target;
          setProfile((prev) => ({
              ...prev,
              [name]: value
          }));
      };*/

      const handleChange = (e) => {
        const { name, value } = e.target;
      
        if (name === "password" || name === "confirm_password") {
          setValues(prev => ({ ...prev, [name]: value }));
        } else {
          setProfile(prev => ({ ...prev, [name]: value }));
        }
      };
  
  
      
  const [previewImage, setPreviewImage] = useState(null);
  
  /*const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result); // Set preview for display
      };
      reader.readAsDataURL(file);
  
      // Update the profile only with the file (for uploading)
      setProfile((prev) => ({
        ...prev,
        profile_image: file
      }));
    }
  };*/

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result); // for preview
      };
      reader.readAsDataURL(file);
  
      setProfile(prev => ({
        ...prev,
        profile_image: file, // File object to send via FormData
      }));
    }
  };


  const [isUpdating, setIsUpdating] = useState(false);

const handleAcceptInvitation = (e) => {
  e.preventDefault();
  setIsUpdating(true); // disable button

  const formData = new FormData();
  formData.append("verify_code", verifyCode);
  formData.append("name", profile.name);
  formData.append("last_name", profile.last_name);
  formData.append("email", profile.email);
  formData.append("phone_number", profile.phone_number);
  formData.append("password", values.password);
  formData.append("confirm_password", values.confirm_password);

  if (profile.profile_image && profile.profile_image instanceof File) {
    formData.append("image_name", profile.profile_image);
  }

  axios.post(`${API_URL}/register-accept-invitation-api`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true
  })
    .then(res => {
      if (res.data.Status === "Success") {
        toast.success("Account setup successful", { position: "top-right", autoClose: 3000 });
        localStorage.removeItem("verify_code");
        navigate(res.data.redirect);
      } else {
        toast.error(res.data.Message, { position: "top-right", autoClose: 3000 });
      }
    })
    .catch(() => {
      toast.error("Something went wrong", { position: "top-right", autoClose: 3000 });
    })
    .finally(() => {
      setIsUpdating(false); // re-enable button
    });
};

  /*const handleAcceptInvitation = (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append("verify_code", verifyCode);
    formData.append("name", profile.name);
    formData.append("last_name", profile.last_name);
    formData.append("email", profile.email);
    formData.append("phone_number", profile.phone_number);
    formData.append("password", values.password);
    formData.append("confirm_password", values.confirm_password);
  
    if (profile.profile_image && profile.profile_image instanceof File) {
      formData.append("image_name", profile.profile_image);
    }
  
    axios.post(`${API_URL}/register-accept-invitation-api`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true
    })
      .then(res => {
        if (res.data.Status === "Success") {
          toast.success("Account setup successful", { position: "top-right", autoClose: 3000 });
          localStorage.removeItem("verify_code");
          navigate(res.data.redirect);
        } else {
          toast.error(res.data.Message, { position: "top-right", autoClose: 3000 });
        }
      })
      .catch(() => {
        toast.error("Something went wrong", { position: "top-right", autoClose: 3000 });
      });
  };*/
  
      //end user details

  
      
      if (isLoading) return <p>Loading packages...</p>;
      if (isError) return <p>Error fetching packages</p>;
      if (!Array.isArray(data)) return <p>No packages found.</p>;
      
    return (
        <div className="main-wrapper bg_med_green ">
    <ToastContainer />
    <div className="container">

        <div className="row justify-content-centerx" style={{marginTop: '5%'}}>

        <div className="col-md-6 ">
        <div className="card ">
        <div className="card-body">

        {data.map((pkg) => (
        <div key={pkg.id}>

        <p style={{fontSize: '18px', fontWeight: '600'}} className="border-bottom py-1">{pkg.name}</p>
        
        {pkg.details.map((detail, idx) => (

    
         <li key={idx} className="border-bottom py-1">{detail}</li>
   
            
        ))}
        </div>
        ))}


        </div>
        </div>    

        <div className='card'>

        <div className="card-body">
  <p style={{ fontSize: '18px', fontWeight: '600' }} className="border-bottom py-1">Family Details</p>

  {isDetailedLoading && <p>Loading...</p>}
  {isDetailedError && <p>Error loading family details</p>}

  {detailedFamily && (
    <div className="row">
      <div className="col-md-12">
        <p><strong>Family name:</strong> {detailedFamily.family_name}</p>
      </div>
      <div className="col-md-12 mt-2">
        <p><strong>Tribe:</strong> {detailedFamily.tribe_name}</p>
      </div>
      {detailedFamily.sub_tribe_name && (
      <div className="col-md-12 mt-2">
        <p><strong>Sub-Tribe:</strong> {detailedFamily.sub_tribe_name}</p>
      </div>
      )}
      {detailedFamily.sub_group_name && (
      <div className="col-md-12 mt-2">
        <p><strong>Sub-Group:</strong> {detailedFamily.sub_group_name}</p>
      </div>
      )}
      {detailedFamily.clan_name && (
      <div className="col-md-12 mt-2">
        <p><strong>Clan:</strong> {detailedFamily.clan_name}</p>
      </div>
      )}
      {detailedFamily.totem_name && (
      <div className="col-md-12 mt-2">
        <p><strong>Totem:</strong> {detailedFamily.totem_name}</p>
        {/*{detailedFamily.totem_image && (
          <img src={`${API_URL}/images/${detailedFamily.totem_image}`} alt="Totem" className="img-fluid mt-2" />
        )}*/}
      </div>
      )}

      <div className="col-md-12 mt-2">
        <p><strong>People you may know:</strong></p>
        
          {detailedFamily.admin.map((admin, idx) => (
            <li style={{marginLeft: '5%'}} key={idx}>
              {admin.n_prefix || ''} {admin.name} {admin.last_name}
            </li>
          ))}
        
      </div>
    </div>
  )}
</div>
       
        </div>

        </div>

            <div className="col-md-6 bg-med-green text-white p-2x">


                                <div className="row">
                        <div className="col-md-12">
                            <center>
                            <div 
                                className="position-relative d-inline-block" 
                                style={{ cursor: 'pointer' }} 
                                onClick={() => document.getElementById('uploadImageInput').click()}
                            >
                                {profile.profile_image && (
                                <div className="mb-3">
                                    <img 
                                    src={previewImage || `${API_URL}/images/${profile.profile_image}`} 
                                    alt="Profile" 
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%', 
                                        border: '2px solid #ccc' 
                                    }}
                                    />
                                </div>
                                )}

                                {/* Edit Icon */}
                                <span 
                                className="avatar-edit bg-transparent shadow-none" 
                                style={{ position: 'absolute', bottom: '5px', right: '5px', 
                                    backgroundColor: '#fff', borderRadius: '50%', padding: '6px', 
                                    boxShadow: '0px 0px 5px rgba(0,0,0,0.2)'
                                }}
                                >
                                <i className="fas fa-edit" style={{ color: '#184A2C', fontSize: '16px' }}></i>
                                </span>

                                {/* Hidden Input */}
                                <input 
                                id="uploadImageInput" 
                                type="file" 
                                accept="image/*" 
                                onChange={handleImageChange} 
                                style={{ display: 'none' }}
                                />
                            </div>
                            </center>
                        </div>
                        </div>



                    <div className="row">
                    <div className="col-6 col-md-6">
                    <label className="control-label">First Name</label>
                    <input type="text" name="name" value={profile.name} onChange={handleChange} placeholder="First Name" className="form-control mb-2" />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="control-label">Last Name</label>
                    <input type="text" name="last_name" value={profile.last_name} onChange={handleChange} placeholder="Last Name" className="form-control mb-2" />
                    </div>
                    
                </div>

                <div className="row">
                    
                    <div className="col-6 col-md-6">
                    <label className="control-label">Your Phone Number</label>
                    <input type="text" name="phone_number" value={profile.phone_number} onChange={handleChange} placeholder="Phone Number" className="form-control mb-2" />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="control-label">Your Email</label>
                    <input type="email" name="email" value={profile.email} onChange={handleChange} placeholder="Email" className="form-control mb-2" />
                    </div>

                </div>

                <div className="row">
                    
                    <div className="col-6 col-md-6">
                    <label className="control-label">New Password</label>
                    <input type="password" name="password" value={profile.password}  onChange={handleChange} placeholder="New Password" className="form-control mb-2" />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="control-label">Confirm Password</label>
                    <input type="password" name="confirm_password" value={profile.confirm_password} onChange={handleChange} placeholder="Confirm Password" className="form-control mb-2" />
                    </div>

                </div>

                <div className='row' style={{marginBottom: '20%'}}>
                <center>
                By signin up, you agree to our master subscription and privacy policy.
                </center>

                    <div className='col-6 col-md-6'>
                        <Link to='' className="btn btn-primary w-100">Reject Invitation </Link>
                    </div>

                    <div className='col-6 col-md-6' style={{textAlign: 'right'}}>
                    <button
                      onClick={handleAcceptInvitation}
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={isUpdating}
                    >
                      {isUpdating ? "Updating..." : "Update & Proceed"}
                    </button>
                    </div>
                </div>
                

            </div>
        </div>
    </div>
</div>

    );
}


export default Welcome;
